export class SortBy {
    field;
    sortOperation;
    constructor(field, sortOperation) {
        this.field = field;
        this.sortOperation = sortOperation;
    }
}
